// M06 變換幾何 - 練習題數據
// 系統化設計，準備後續 Supabase 數據遷移

export const M06_TOPICS = [
  {
    id: 'M06_01',
    name: "平移變換",
    description: "學習圖形的平移變換",
    order: 1
  },
  {
    id: 'M06_02',
    name: "反射變換",
    description: "學習圖形的反射變換",
    order: 2
  },
  {
    id: 'M06_03',
    name: "旋轉變換",
    description: "學習圖形的旋轉變換",
    order: 3
  },
  {
    id: 'M06_04',
    name: "縮放變換",
    description: "學習圖形的縮放變換",
    order: 4
  },
  {
    id: 'M06_05',
    name: "複合變換",
    description: "學習多種變換的組合",
    order: 5
  },
  {
    id: 'M06_06',
    name: "變換矩陣",
    description: "使用矩陣表示變換",
    order: 6
  },
  {
    id: 'M06_07',
    name: "逆變換",
    description: "學習變換的逆運算",
    order: 7
  },
  {
    id: 'M06_08',
    name: "幾何證明",
    description: "使用變換進行幾何證明",
    order: 8
  }
];

export const M06_MODULE_INFO = {
  moduleId: 'M06',
  title: '變換幾何',
  description: '學習幾何圖形的各種變換',
  totalTopics: M06_TOPICS.length,
  estimatedTime: '7-9小時',
  difficulty: 'Intermediate',
  prerequisites: ['基本幾何概念', '坐標系統'],
  learningOutcomes: [
    '掌握基本幾何變換',
    '理解變換的性質',
    '能夠進行複合變換',
    '使用變換解決幾何問題',
    '理解變換的矩陣表示'
  ]
}; 